enum TextButtonTheme {
  Navy = "Navy",
  Purple = "Purple",
  White = "White",
}

export default TextButtonTheme;
